export const locales = [
  {
    name: 'ICC Sul',
    complete: 'Instituto Central de Ciências Sul',
    position: 1,
    coordinates: [-15.765269, -47.867354],
  },
  {
    name: 'ICC Norte',
    complete: 'Instituto Central de Ciências Norte',
    position: 2,
    coordinates: [-15.761304, -47.87039],
  },
  {
    name: 'BSA Sul',
    complete: 'Blocos de Sala de Aula Sul',
    position: 3,
    coordinates: [-15.76706, -47.866538],
  },
  {
    name: 'BSA Norte',
    complete: 'Blocos de Sala de Aula Norte',
    position: 4,
    coordinates: [-15.75706, -47.871296],
  },
  {
    name: 'RU',
    complete: 'Restaurante Universitário',
    position: 5,
    coordinates: [-15.764071, -47.87054],
  },
  {
    name: 'PAT',
    complete: 'Pavilhão Anísio Teixeira',
    position: 6,
    coordinates: [-15.759182, -47.870776],
  },
  {
    name: 'PJC',
    complete: 'Pavilhão João Calmon',
    position: 7,
    coordinates: [-15.758423, -47.870175],
  },
  {
    name: 'BCE',
    complete: 'Biblioteca Central',
    position: 8,
    coordinates: [-15.761087, -47.867879],
  },
  {
    name: 'FT',
    complete: 'Faculdade de Tecnologia',
    position: 9,
    coordinates: [-15.763789, -47.872505],
  },
  {
    name: 'ULEG',
    complete: 'Unidade de Laboratórios',
    position: 10,
    coordinates: [-15.761532, -47.873929],
  },
  {
    name: 'SG 12',
    complete: 'Laboratórios de Engenharia Civil',
    position: 11,
    coordinates: [-15.765228, -47.872457],
  },
  {
    name: 'SG 11',
    complete: 'Laboratórios de Engenharia Elétrica',
    position: 12,
    coordinates: [-15.76484, -47.872092],
  },
  {
    name: 'IDA',
    complete: 'Instituto de Artes',
    position: 13,
    coordinates: [-15.7656, -47.870429],
  },
  {
    name: 'FD',
    complete: 'Faculdade de Direito',
    position: 14,
    coordinates: [-15.759312, -47.87236],
  },
  {
    name: 'FACE',
    complete: 'F. Economia, Adm., Contabilidade',
    position: 15,
    coordinates: [-15.758455, -47.871641],
  },
  {
    name: 'CIC/EST',
    complete: 'Ciência da Computação e Estatística',
    position: 16,
    coordinates: [-15.758538, -47.868973],
  },
  {
    name: 'Reitoria',
    complete: 'Reitoria Central da UnB',
    position: 17,
    coordinates: [-15.762872, -47.866942],
  },
  {
    name: 'IB',
    complete: 'Instituto de Ciências Biológicas ',
    position: 18,
    coordinates: [-15.765763, -47.865794],
  },
  {
    name: 'FEF',
    complete: 'Faculdade de Educação Física',
    position: 19,
    coordinates: [-15.76313, -47.860644],
  },
  {
    name: 'CDT',
    complete: 'C. de Desenvolvimento Tecnológico',
    position: 20,
    coordinates: [-15.774622, -47.866812],
  },
  {
    name: 'CO',
    complete: 'Centro Olímpico',
    position: 21,
    coordinates: [-15.76328, -47.857806],
  },
  {
    name: 'MASC Central',
    complete: 'Amarelinho Central',
    position: 22,
    coordinates: [-15.763108, -47.871206],
  },
  {
    name: 'MASC Norte',
    complete: 'Amarelinho Norte',
    position: 23,
    coordinates: [-15.758246, -47.871024],
  },
  {
    name: 'MASC Sul',
    complete: 'Amarelinho Sul',
    position: 24,
    coordinates: [-15.767823, -47.86554],
  },
  {
    name: 'IQ',
    complete: 'Instituto de Química',
    position: 25,
    coordinates: [-15.76854, -47.864817],
  },
  {
    name: 'IPOL/IREL',
    complete: 'C. Políticas e Rel. Internacionais',
    position: 26,
    coordinates: [-15.758293, -47.869441],
  },
  {
    name: 'FS',
    complete: 'Faculdade de Saúde',
    position: 27,
    coordinates: [-15.768623, -47.866806],
  },
];
